import './App.css';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { SocketProvider } from './context/SocketContext';
import { PlanProvider } from './context/PlanContext';
import UpgradeModal from './Component/UpgradeModal';
import Billing from './Component/Billing';
import Current from './Component/Current';
import Completed from './Component/Completed';
import Incompleted from './Component/Incomplete';
import Assigned from './Component/Assigned';
import FetchLocation from './Component/FetchLocation';
import Driver from './Component/Driver';
import Report from './Component/Report';
import Driverpdf from './Component/Driverpdf';
import DeliveryChart from './Component/DeliveryChart';
import DriverTable from './Component/DriverTable';
import Packer from './Component/Packer';
import OrderExcel from './Component/OrderExcel';
import DetailsQR from './Component/DetailsQR'
import Mapping from './Component/Mapping';
import Update from './Component/Update';
import Registration from './Component/Registration';
import ResetPassword from './Component/ResetPassword';
import Setting from './Component/Settings';
import LocationLogMap from './Component/LocationLogMap';
import OldBills from './Component/OldBills';
import Dispatcher from './Component/Dispatcher';
import DeployComponent from './Component/DeployComponent';
import Timeline from './Component/Timeline';
import Dashboard from './Component/Dashboard';
import ReportId from './Component/ReportId';
import Summary from './Component/Summary';
import Accounts from './Component/Account';
import Ledgers from './Component/Ledgers';
import Test from './Component/Test';
import Login from './Component/LoginForm';
import Result from './Component/Result';
import SummaryOrder from './Component/SummaryOrder';
import Pending from './Component/Pending';
import QueueDataList from './Component/QueueDataList';
import PackerLanding from './Component/PackerLanding';
import PackerOrders from './Component/PackerOrders';
import PackerSummaries from './Component/PackerSummaries';
import PackageDetails from './Component/PackageDetails';
import PrintDetails from './Component/PrintDetails';
import ActiveDriversPage from './Component/DriverStatus/ActiveDriverPage';
import DriverProfilePage from './Component/DriverProfile/DriverProfilePage'
import LoginPage from './Component/LoginPage';
import BillToCollect from './Component/BillToCollect';
import Marketing from './Component/Marketing';
import CustomerDataList from './Component/CustomerDataList';
import WhatsappReplies from './Component/WhatsappReplies';
import PaymentReminders from './Component/PaymentReminders';
import PaymentSettings from './Component/PaymentSettings';
import RouteOptimization from './Component/RouteOptimization';

const ProtectedRoute = ({ element }) => {
  const isAuthenticated = () => {
    const token = sessionStorage.getItem('token');
    return token ? true : false;
  };

  return isAuthenticated() ? element : <Navigate to="/" />;
};

function App() {
  return (
    <div className="App">
      <SocketProvider>
        <PlanProvider>
        <BrowserRouter>
          <UpgradeModal />
          <Routes>
            <Route path='/' element={<LoginPage />}></Route>
            <Route path='/signup' element={<Registration />}></Route>
            <Route path="/forgot" element={<ResetPassword />} />
            <Route path="/CurrentOrder" element={<ProtectedRoute element={<Current />} />} />
            <Route path="/Billing" element={<ProtectedRoute element={<Billing />} />} />
            <Route path="/DriverTable" element={<ProtectedRoute element={<DriverTable />} />} />
            <Route path="/Packer" element={<ProtectedRoute element={<Packer />} />} />
            <Route path="/Map" element={<ProtectedRoute element={<Mapping />} />} />
            <Route path="/Reports" element={<ProtectedRoute element={<Report />} />} />
            <Route path="/CompleteOrder" element={<ProtectedRoute element={<Completed />} />} />
            <Route path="/IncompleteOrder" element={<ProtectedRoute element={<Incompleted />} />} />
            <Route path="/AssignedOrder" element={<ProtectedRoute element={<Assigned />} />} />
            <Route path="/track" element={<ProtectedRoute element={<FetchLocation />} />} />
            <Route path="/report" element={<ProtectedRoute element={<Report />} />} />
            <Route path="/driver" element={<ProtectedRoute element={<Driver />} />} />
            <Route path="/driverpdf/:name/:date/:time" element={<ProtectedRoute element={<Driverpdf />} />} />
            <Route path="/delivery" element={<ProtectedRoute element={<DeliveryChart />} />} />
            <Route path="/orderExcel" element={<ProtectedRoute element={<OrderExcel />} />} />
            <Route path="/order-details" component={<ProtectedRoute element={DetailsQR} />} />
            <Route path="/update/:selectedDriverId/:driverEmail" element={<ProtectedRoute element={<Update />} />} />
            <Route path="/settings" element={<ProtectedRoute element={<Setting />} />} />
            <Route path="/map-view" element={<ProtectedRoute element={<LocationLogMap />} />} />
            <Route path="/OldBills" element={<ProtectedRoute element={<OldBills />} />} />
            <Route path="/Dispatcher" element={<ProtectedRoute element={<Dispatcher />} />} />
            <Route path='/deploy' element={<ProtectedRoute element={<DeployComponent />} />} />
            <Route path='/timeline/:orderId' element={<ProtectedRoute element={<Timeline />} />} />
            <Route path='/dashboard' element={<ProtectedRoute element={<Dashboard />} />} />
            <Route path='/reportId' element={<ProtectedRoute element={<ReportId />} />} />
            <Route path='/summary' element={<ProtectedRoute element={<Summary />} />} />
            <Route path='/account' element={<ProtectedRoute element={<Accounts />} />} />
            <Route path='/Ledgers' element={<ProtectedRoute element={<Ledgers />} />} />
            <Route path='/SummaryOrder' element={<ProtectedRoute element={<SummaryOrder />} />} />
            <Route path='/Pending' element={<ProtectedRoute element={<Pending />} />} />
            <Route path='/BillToCollect' element={<ProtectedRoute element={<BillToCollect />} />} />
            <Route path='/Test' element={<Login />} />
            <Route path='/testGenerated' element={<Test />} />
            <Route path='/resultForAll' element={<Result />} />
            <Route path='/getQueue' element={<ProtectedRoute element={<QueueDataList />} />} />
            <Route path='/packerLanding' element={<ProtectedRoute element={<PackerLanding />} />} />
            <Route path='/packerOrders' element={<ProtectedRoute element={<PackerOrders />} />} />
            <Route path='/packerSummaries' element={<ProtectedRoute element={<PackerSummaries />} />} />
            <Route path='/packageDetails' element={<ProtectedRoute element={<PackageDetails />} />} />
            <Route path='/printDetails' element={<ProtectedRoute element={<PrintDetails />} />} />
            <Route path='/ActiveDrivers' element={<ActiveDriversPage />} />
            <Route path='/DriverProfile/:name' element={<DriverProfilePage />} />
            <Route path='/Marketing' element={<Marketing />} />
            <Route path='/customer-data-list' element={<CustomerDataList />} />
            <Route path='/customer-whatsapp-replies' element={<WhatsappReplies />} />
            <Route path='/PaymentReminders' element={<ProtectedRoute element={<PaymentReminders />} />} />
            <Route path='/PaymentSettings' element={<ProtectedRoute element={<PaymentSettings />} />} />
            <Route path='/RouteOptimization' element={<ProtectedRoute element={<RouteOptimization />} />} />
          </Routes>
        </BrowserRouter>
        </PlanProvider>
      </SocketProvider>
    </div>
  );
}

export default App;